export const NEW_POST_BOX = 'new-post-box';
